(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .factory('SoopService', SoopService);

    SoopService.$inject = ['SoopkitchenUtils', '$http'];

    function SoopService(SoopkitchenUtils, $http) {

        return {
            moveSoop: moveSoop,
        };

        function successMoveSOOP(soopType, soopInstanceId, time, cut, extraCallback) {
            return function (response) {
                var verb = 'copied';
                if (cut) verb = 'moved';
                var title = "SOOP Instance has been " + verb;
                var msg = "SOOP Instance '[" + soopType + ',' + soopInstanceId + "]' has been " + verb + " to " + time;
                SoopkitchenUtils.processResponse(
                    response,
                    title,
                    msg,
                    extraCallback(response)
                );
            }
        }

        function getFailureCallback(extraCallback) {
            return function(response) {
                if (extraCallback) {
                    extraCallback();
                } 
                SoopkitchenUtils.prettyError(response);
            }
        }

        function moveSoop(planType, planLabel, soopInstanceId, encodedSoopType, soopType, anchorTime, cut, successCallback, errorCallback) {
            $http({
                method: 'PUT',
                url: 'api/' + planType + '/soop-move',
                params: {
                    'planLabel': planLabel,
                    'soopInstanceId': soopInstanceId,
                    'encodedSoopType': encodedSoopType,
                    'anchorDate': anchorTime,
                    'copy': !cut
                }
            }).then(successMoveSOOP(soopType, soopInstanceId, anchorTime, cut, successCallback), getFailureCallback(errorCallback));
        }

    }
})();
